<template>
  <div
    class="card-rectangle card-component relative"
    @click="handleClick"
    :class="{ active: isSelected }"
  >
    <div class="absolute gradient-bg"></div>
    <p>
      {{ title }}
    </p>
  </div>
</template>

<script>
import { GETTERS, MUTATIONS } from "../../../store/wizard/types";
import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    prop: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      catalog: GETTERS.GET_CATALOG,
      consult: GETTERS.GET_CONSULT
    }),
    isSelected() {
      return this.consult[this.prop] === this.id;
    }
  },

  methods: {
    ...mapMutations({
      setConsult: MUTATIONS.SET_CONSULT
    }),
    handleClick() {
      this.setConsult({
        ...this.consult,
        [this.prop]: this.id
      });
      this.$nextTick(() => {
        this.$emit("click");
      })
    }
  },

  mounted() {
    this.$el.style.width = `${this.width}px`;
  }
};
</script>
